import axios from "axios";
import { msalInstance, appRequest } from "./authentication/authConfig";

const getAntiForgeryToken = async () => {
  try {
    const response = await axios.get("antiforgery/token"); // Adjust the endpoint as necessary
    localStorage.setItem("csrf", response.data);
    return response.message;
  } catch (error) {
    console.error("Failed to refresh AntiForgeryToken:", error);
    throw error;
  }
};

// Request interceptor to add token
axios.interceptors.request.use(
  async (config) => {
    // We can do anything before request is sent
    const accounts = msalInstance.getAllAccounts();
    if (accounts) {
      const configCopy = { ...config };
      let tokenResponse = null;
      try {
        tokenResponse = await msalInstance.acquireTokenSilent({
          ...appRequest,
          account: accounts[0],
        });
      } catch {
        msalInstance.logoutRedirect().catch(() => {
          console.error("Something went wrong while logging out");
        });
      }
      if (tokenResponse?.accessToken) {
        const bearer = `Bearer ${tokenResponse.accessToken}`;
        if (configCopy.method !== "get") {
          const xsrfToken = localStorage.getItem("csrf");
          if (!xsrfToken) console.error("No CSRF Token");
          configCopy.headers["X-Xsrf-Token"] = xsrfToken;
        }
        configCopy.headers["project-name"] = "partner portal";
        configCopy.headers.Authorization = bearer;
        return configCopy;
      }
    }
    return Promise.reject(new Error("Some Error Occurred in Interceptors"));
  },
  (error) => Promise.reject(new Error(error))
);

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    console.warn(error.response);
    if (
      error.response.status === 400 &&
      error.response.data.message === "Antiforgery token validation failed."
    ) {
      try {
        const token = await getAntiForgeryToken();
        originalRequest.headers["X-Xsrf-Token"] = token;

        return axios(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);

        msalInstance.logoutRedirect().catch(() => {
          console.error("Something went wrong while logging out");
        });

        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
